import { render, staticRenderFns } from "./bullScrotalCircumferenceMeanMeasurement.vue?vue&type=template&id=1c47c13c&scoped=true&"
import script from "./bullScrotalCircumferenceMeanMeasurement.vue?vue&type=script&lang=js&"
export * from "./bullScrotalCircumferenceMeanMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47c13c",
  null
  
)

export default component.exports